var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h1',[_vm._v("Affiliates")]),_c('ResponsiveTable',{attrs:{"headers":['Name', 'Domain', 'Courses', ''],"rows":_vm.affiliates}}),_c('BaseButton',{attrs:{"type":"primary","href":{name: 'AdminAffiliateAdd'}}},[_vm._v(" Add affiliate ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }